import { InformationCircleIcon } from '@heroicons/react/solid';
import { Tooltip } from 'react-tooltip';
import React from 'react';
import { ITooltip } from 'react-tooltip';
type ObjectiveTooltipProps = {
  tooltipId: string;
  tooltipPlace: 'top' | 'right' | 'bottom' | 'left';
  htmlContent: string;
  place?: string;
  offset?: number;
  style?: React.CSSProperties;
};

const ObjectiveTooltip = ({
  tooltipId,
  tooltipPlace,
  htmlContent,
  place,
  offset,
  style,
}: ObjectiveTooltipProps): React.ReactElement => {
  const customProps = {
    place: place,
    offset,
    style,
  };

  return (
    <>
      <Tooltip id={tooltipId} {...(customProps as ITooltip)} />
      <InformationCircleIcon
        className="flex-shrink-0 h-4 w-4 ml-[-2] cursor-pointer"
        aria-hidden="true"
        data-tooltip-html={htmlContent}
        data-tooltip-place={tooltipPlace}
        data-tooltip-id={tooltipId}
      />
    </>
  );
};

export default ObjectiveTooltip;
